import React from "react";
import { motion } from "framer-motion";
import hvacDesign from "../assets/services/Design.jpeg";
import equipSupply from "../assets/services/equip-supply.png";
import installation from "../assets/services/installation-ac.jpeg";
import repairMaintain from "../assets/services/HVAC-design.jpeg";
import optimization from "../assets/services/Energy Audit.jpeg";
import consultancy from "../assets/services/consultancy.png";
import { Link } from "react-router-dom";

const services = [
  { image: hvacDesign,     title: "HVAC Design",                desc: "Full engineering design for HVAC systems in any building type — residential, commercial, or industrial." },
  { image: equipSupply,    title: "Equipment Supply",           desc: "Supply of premium HVAC equipment from leading global brands at competitive prices with full manufacturer warranty." },
  { image: installation,   title: "Installation Services",      desc: "Professional installation of all HVAC system types by qualified, experienced, and safety-trained technicians." },
  { image: repairMaintain, title: "Repairs & Maintenance",      desc: "Rapid fault diagnosis and professional repair services with emergency call-out availability for urgent failures." },
  { image: optimization,   title: "Energy Audits & Optimization", desc: "In-depth assessment of existing HVAC systems to identify energy waste and recommend cost-saving improvements." },
  { image: consultancy,    title: "Technical Consultancy",      desc: "Expert HVAC advisory for developers, architects, contractors, facility managers, and project owners." },
];

export default function Services() {
  return (
    <section className="bg-white py-10 sm:py-16 font-poppins">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Title — drops in from top */}
        <motion.div
          className="flex justify-center mb-8 sm:mb-10"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.6 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <h2
            className="text-xl sm:text-4xl rounded-md font-extrabold text-white px-8 sm:px-12 py-3 tracking-widest"
            style={{ backgroundColor: "#0F1030" }}
          >
            SERVICES
          </h2>
        </motion.div>

        {/* 1 col mobile, 2 col tablet, 3 col desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              className="group cursor-pointer"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.55, ease: "easeOut", delay: i * 0.12 }}
            >
              <div className="rounded-xl overflow-hidden h-44 sm:h-48 mb-3 sm:mb-4">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-bold text-base sm:text-lg mb-2" style={{ color: "#0F1030" }}>
                {s.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{s.desc}</p>
              
              <Link
                to="/contact"
                className="inline-block text-xs sm:text-sm font-bold tracking-wide px-5 py-2 transition-colors duration-200"
                style={{ backgroundColor: "#00C7EF", color: "#0F1030" }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#0F1030"; e.currentTarget.style.color = "#ffffff"; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#00C7EF"; e.currentTarget.style.color = "#0F1030"; }}
              >
                LEARN MORE
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}